import { QuotationVOsV2 } from './QuotationVOV2.model';

export class QuotationScheduleVOV2 {
  "quotationVOs": QuotationVOsV2[];
}
